jQuery(document).ready( function(){
    jQuery('body').addClass( 'DomLoaded' );
    /*console.log( "Store Info:", {
        store_url: document.location.origin,
        backend: get_backend_url(),
        laravelApiUrl: laravelApiUrl,
        user_status_manager: user_status_manager
    });*/
    
    user_status_manager.init();
    homeapp_modal.init();

    let order_page_init_redirect_should_run = true;
    /*jQuery(document).on( 'userStatusFetched', function( event ){
        if( order_page_init_redirect_should_run ){
            if( menu.open ){ // Check if menu is open
                if( user_status_manager.get_user_status() ){ // returns true/false
                    if( isPage( 'order-now' ) ){
                        const onUrlParams = new window.URLSearchParams(window.location.search);
                        if(onUrlParams.get('menu') && onUrlParams.get('menu')=='main-menu'){
                          // Stay in order-now page
                        } else {
                          window.location.href = get_backend_path( 'order' ); // redirect to ordering site
                        }
                    }
                }
            }
            order_page_init_redirect_should_run = false;
        }
    });*/

    let $_create_account_modal = $( '.create-account-modal' );
    
    if( $_create_account_modal.length ){

        // let $_statesDropdown = $( 'select[name="customer[state]"]', $_create_account_modal );

        // if( $_statesDropdown.length ){
            
        //     let USstatesOptionsHTML = '';
    
        //     for( let [ stateCode, StateName ] of Object.entries( usStates() )){
        //         USstatesOptionsHTML += `<option value="${stateCode}">${StateName}</option>`;
        //     }

        //     $_statesDropdown.append( USstatesOptionsHTML );

        // }

        let queryParamsString = document.location.search;
        //console.log( "Looking for search params" );
        if( queryParamsString ){

            let queryParams = new URLSearchParams( queryParamsString );

            if( queryParams.get( 'accountSignUp' ) === '1' ){
                
                //console.log( "Account Popup should open" );
                $('.create-account-btn').trigger( 'click' );
                        
                $( '#zipcodeInputCA', $_create_account_modal ).val( queryParams.get( 'zip' ) );
                $( '#createAccountZipcodeCheck', $_create_account_modal ).trigger( 'click' );

                // let $_create_customer_form = $( '#create_customer' );
                $( 'input[name="customer[first_name]"]', $_create_account_modal ).val( queryParams.get( 'firstName' )  );
                $( 'input[name="customer[last_name]"]', $_create_account_modal ).val( queryParams.get( 'lastName' )  );
                $( 'input[name="customer[phone]"]', $_create_account_modal ).val( queryParams.get( 'phone' )  );
                $( 'input[name="customer[email]"]', $_create_account_modal ).val( queryParams.get( 'email' )  );
                $('input[name="ty_signup_click_id"]', $_create_account_modal).val(queryParams.get('buttonClickId'));
                
                window.history.replaceState({}, document.title, "/" );
              
                $('.create-account-modal .zipcode-valid').css('display', 'none');


            }else if( queryParams.get( 'action' ) === 'login' ){
                let signInBtn = $('#btnSignIn');
                //console.log( "Login popup should open" );
                if( signInBtn.length ){
                    signInBtn.trigger( 'click' );
                }
            }
        }
    }

    $_zip_code_validated_order_btn = $( '.zip-code-validated-order-btn' );
    
    $_zip_code_validated_order_btn.on( 'click', function(event){
        
        if( !homeAppGlobalSettings.isMenuOpen ){ // If menu is not open, we probably don't want the order button to work
            event.preventDefault();
            return false;
        }

        // let urlParams = new URLSearchParams(window.location.search);
        // getZipcode = urlParams.get('zipcode');
        const getZipcode = getCookie('zipcode');
        if( user_status_manager.get_user_status() ){ // if true user is logged in. We don't need to ask for zip code for logged in user so just redirect user
            let href = $('.zip-code-validated-order-btn').attr('href');  
            window.location.href = href;
        }else if( !getZipcode ){
            // event.preventDefault();
            homeapp_modal.open( 'zip-code-validation-popup' );
            // return false;
        }else if (getZipcode){
            // event.preventDefault();
            let href = $('.zip-code-validated-order-btn').attr('href')+'?zipcode='+getZipcode.trim();  
            window.location.href = href;
            // return false;
        }

        event.preventDefault();
        return false;
    });


    let goto_order_link = $('.goto-order-page');
    if( goto_order_link.length ){
        goto_order_link.on( 'click', function( event ){
            if( user_status_manager.get_user_status() && isMenuOpen() ){
                event.preventDefault();
                window.location.href = get_backend_path( 'order' );
            }
        });
    }

    if( isPage( 'order-now' ) ){
        let orderNowBtn = $('#btnOrderNow');
        orderNowBtn.on( 'click', function(event){
            if( isMenuOpen() ){
                let orderCTA = $('.place-order-cta');
                if( orderCTA.length ){
                    orderCTA.trigger('click');
                    event.preventDefault();
                }
            }
        });
    }

    $(document).on('click', '.close-btn-ca', function (e) {
        e.preventDefault();
        var tySignupClickId = $('input[name="ty_signup_click_id"]').val();
        if(tySignupClickId!==undefined || tySignupClickId!==null || tySignupClickId!=""){
          updateSignupNotComplete(tySignupClickId);
        }
    });
});

async function updateSignupNotComplete(id){
  let getUpdateSignupResponse = await fetch(get_laravel_api_url() +"/tracking/click/not/signup", {
        method: 'POST',
        body: JSON.stringify({ id: `${id}` }),
        headers: {
            'Content-Type': 'application/json',
            "Accept-Encoding": "gzip,deflate,compress"
        }
    });
  //let updateResponse = await getUpdateSignupResponse.json();
  //console.log(updateResponse);
}

async function doesDeliverToZipCode ( zipCode ){
    // console.log( "Checking Zip Code:", {
    //     zipCode
    // })

    let getDoesDeliverResponse = await fetch( get_laravel_api_url() + "/delivery/zipcode/validate", {
        method: 'POST',
        body: JSON.stringify({ zipcode: `${zipCode}` }),
        headers: {
            'Content-Type': 'application/json',
            "Accept-Encoding": "gzip,deflate,compress"
        }
    } );

    let doesDeliver = await getDoesDeliverResponse.json();
    if( doesDeliver.status === false ){
        gtag( 'event', 'out_of_delivery_zone', {
            'zipcode' : zipCode
        } );
    }
    return doesDeliver.status;
    // console.log( doesDeliver );

    // return true;


    // let doesDeliver = false;

    let searchZipCode = zipArray.find( ( zipElement ) => {
        return parseInt(zipElement.zipcode.trim()) === parseInt(zipCode.trim());
    });

    if( searchZipCode ){
        doesDeliver = true;
    }

    if( doesDeliver === false ){
        gtag( 'event', 'out_of_delivery_zone', {
            'zipcode' : zipCode
        } );
    }

    return doesDeliver;

}

async function validateZipCode( element = false, zipCode ){

    let elementCurrentText = '';

    if( element ){

        element = $( element );
    
        elementCurrentText = element.text();
        element.text( 'Checking' );

    }


    let doesDeliver = await doesDeliverToZipCode( zipCode );

    if( element ){
        element.text( elementCurrentText );
    }

    console.log( "Does Deliver:", doesDeliver );

    return doesDeliver;

}



function usStates(){
    return {"AL":"Alabama","AK":"Alaska","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DE":"Delaware","FL":"Florida","GA":"Georgia","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PA":"Pennsylvania","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming"}
}


jQuery(function($){
    if(!$(".button").hasClass("btn")){
        $(".button").addClass("btn-primary-small");
     }
     $(".rte a").addClass('ha-a');

  gsap.config({
      nullTargetWarn: false,
      trialWarn: false,
    });
});

gsap.registerPlugin(ScrollTrigger);

var scrollPercentage = -25;

let element1 = document.querySelector('.home-top-element-parallax');
let element2 = document.querySelector('.hiw-design-element');
let element3 = document.querySelector('.newsletter-design-element');
let element4 = document.querySelector('.faq-design-element-1');
let element5 = document.querySelector('.faq-design-element-2');
let element6 = document.querySelector('.witb-design-element');
let element7 = document.querySelector('.mts-design-element');
let element8 = document.querySelector('.lp-heading-design-element');
let element9 = document.querySelector('.lp-newsletter-design-element');
let element10 = document.querySelector('.lp-design-element');
let element11 = document.querySelector('.multicolumn-check-container .column-item .column-icon img');


if(element1) {
  gsap.to(".home-top-element-parallax", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".home-top-element-parallax",
       scrub: true,
    },
});
}

if(element2) {
gsap.to(".hiw-design-element", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".hiw-design-element",
       scrub: true,
    },
});
}

if(element3) {
gsap.to(".newsletter-design-element", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".newsletter-design-element",
       scrub: true,
    },
});
}

if(element4) {
gsap.to(".faq-design-element-1", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".newsletter-design-element",
       scrub: true,
    },
});
}


if(element5) {
gsap.to(".faq-design-element-2", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".newsletter-design-element",
       scrub: true,
    },
});
}

if(element6) {
gsap.to(".witb-design-element", {
    yPercent: 100,
    ease: "none",
    scrollTrigger: {
       trigger:".witb-design-element",
       scrub: true,
    },
});
}

if(element7) {
gsap.to(".mts-design-element", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".mts-design-element",
       scrub: true,
    },
});
}

if(element8) {
gsap.to(".lp-heading-design-element", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".lp-heading-design-element",
       scrub: true,
    },
});
}

if(element9) {
gsap.to(".lp-newsletter-design-element", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".lp-newsletter-design-element",
       scrub: true,
    },
});
}

if(element10) {
gsap.to(".lp-design-element", {
    yPercent: scrollPercentage,
    ease: "none",
    scrollTrigger: {
       trigger:".lp-design-element",
       scrub: true,
    },
});
}

if(element11) {
gsap.from(".multicolumn-check-container .column-item .column-icon img", {duration: 1, opacity: 0, y: 100, stagger: 0.15, scrollTrigger:{
        start: 10,
    }});
}

var setCookie = function(name, value, expDays) {
    let date = new Date();
    if(expDays===-1){

    }else{
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    }
    const expires = "expires=" + date.toUTCString();
    if (window.location.hostname === 'localhost') {
        document.cookie = name + '=' + value + '; expires=' + expires + ';path=/; Secure; SameSite=Lax;';// cannot be HttpOnly
    } else {
        document.cookie = name + '=' + value + '; expires=' + expires + ';path=/; domain=.homeappetitphilly.com; Secure; SameSite=Lax;';// cannot be HttpOnly
    }
}

// var getCookie = function(name) {
//     var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'));
//     return match ? match[2] : null;
// }

var saveNonServiceZipCode = function(email, zipcode) {
  let dataToSend = {
      email: email,
      zipcode: zipcode,
  };

  let postBody = [];
  for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      postBody.push(encodedKey + '=' + encodedValue);
  }
  postBody = postBody.join('&');
  
  const savenoservicezip = fetch(laravelApiUrl + '/save/noservice/zipcode', {
    	method: 'POST',
    	headers: {
    		Accept: 'application/json',
    		'Content-Type': 'application/json',
    		'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    	},
    	body: postBody,
    }).then(response => {
    	if(response.ok) return response.json();
    
    	//if not, throw a error
    	throw new Error('Unable to submit data.');
    }).then(response => {
    	if(response.status=='ok'){
    		//console.log('Successfully added zipcode with account.');
    	}
    }).catch(err => console.error(err));
}

// 
class RefCookieClass {
    constructor() {
      this.cookieName = "referredby";
    }
  
    setCookieIfRefExists() {
      const urlParams = new URLSearchParams(window.location.search);
      const refParameter = urlParams.get("referral");
      if (refParameter) {
          if(refParameter.startsWith('REF-')){
            // const expirationDate = new Date();
            // expirationDate.setFullYear(expirationDate.getFullYear() + 1); // Set cookie expiration to 1 year from now
            setCookie(this.cookieName, refParameter, 365);
            // document.cookie = `${this.cookieName}=${refParameter}; expires=${expirationDate.toUTCString()}; path=/`;
        }else{
            setCookie(this.cookieName, refParameter, -1);
        }
      }
    }

    getRefCookieValue() {
      return getCookie(this.cookieName);
    }

    deleteRefCookie() {
      setCookie(this.cookieName, '', -1);
      const originURL = location.href.split("?")[0];
      window.history.pushState({}, document.title, originURL);
    }
  }
  
  const RefCookie = new RefCookieClass();
  RefCookie.setCookieIfRefExists();